import { LoadingOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

import * as Styled from './Loading.styles';

const antIcon = <LoadingOutlined style={{ fontSize: '2.5em' }} />;

type LoadingProps = {
  isFullScreen?: boolean;
};

const Loading = ({ isFullScreen }: LoadingProps) => {
  const { t } = useTranslation();

  return (
    <Styled.Background $isFullScreen={isFullScreen}>
      <Styled.Spinner indicator={antIcon} tip={t('loading')} />
    </Styled.Background>
  );
};

export default Loading;
